import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Logo } from "./Logo";

const FOOTER_LINKS = [
  { to: "/#about", label: "The project" },
  { to: "/#survey", label: "Survey" },
  { to: "/#news", label: "Headlines" },
  { to: "/#voices", label: "Voices" },
  { to: "/big-games", label: "Big games" },
  { to: "/research", label: "Research" },
  { to: "/results", label: "Results" },
  { to: "/talk-to-us", label: "Talk to us" },
];

const Footer = () => (
  <footer className="bg-pitch dark:bg-card text-cream">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-14">
      <div className="flex flex-col md:flex-row justify-between gap-10">
        <div className="max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2.5">
            <Logo className="h-10 w-10" />
            <span className="font-display font-bold text-xl tracking-tight">Sidelines</span>
          </Link>
          <p className="mt-4 text-cream/70 text-sm leading-relaxed">
            A friendly research project into youth football in Morbi — why we watch, why we
            talk, and why some of us never play.
          </p>
        </div>
        <nav className="grid grid-cols-2 gap-x-12 gap-y-3" aria-label="Footer">
          {FOOTER_LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="text-left text-sm text-cream/70 hover:text-cream transition-colors w-fit">
              {l.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="mt-12 pt-6 border-t border-cream/15 flex flex-col sm:flex-row justify-between gap-4 text-xs text-cream/60">
        <p className="inline-flex items-center gap-1.5">
          Made with <Heart className="h-3.5 w-3.5 fill-flame text-flame" /> by a 15-year-old who
          loves this game
        </p>
        <p>
          A school research project · anonymous answers only ·{" "}
          <Link to="/admin" className="underline underline-offset-2 hover:text-cream transition-colors">
            Owner login
          </Link>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
